/**
 * 자료실 카테고리 id가 속한 그룹(라벨·목록 경로)을 반환한다.
 *
 * 기존 등록/수정 페이지가 각자 if-else로 들고 있던 분기를 한 곳에 모은 것.
 * (route param이 문자열로 와도 안전하도록 Number로 정규화 — 기존 등록 헤더가
 *  문자열 === 비교 탓에 7~11 그룹에서 빈 제목이 나오던 문제도 함께 해결)
 */
const GROUPS = [
  { label: "회칙", path: "/dataCollection/bylaws", ids: [1, 2, 3, 4, 5, 6] },
  { label: "의결기구", path: "/dataCollection/votingBody", ids: [7, 8] },
  { label: "예/결산", path: "/dataCollection/budget", ids: [9, 10] },
  { label: "양식", path: "/dataCollection/other", ids: [11] },
];

const DEFAULT_GROUP = { label: "", path: "/dataCollection/bylaws" };

export const getDataCategoryGroup = (categoryId) => {
  const id = Number(categoryId);
  const group = GROUPS.find((g) => g.ids.includes(id));
  return group || DEFAULT_GROUP;
};

export default getDataCategoryGroup;
